import axios from 'axios'
import { AUTH_URL, getAuthHeader } from '@/services/api.service.js'
import { logger } from '@/utils/logger'

export async function getSuperAdmins() {
  try {
    const ret = await axios.get(`${AUTH_URL}/super-admins`, {
      headers: { ...(await getAuthHeader()) }
    })

    if (ret.status === 200) {
      return ret.data
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.error(error.message)
    return []
  }
}

export async function createSuperAdmin({ email, type }) {
  try {
    const ret = await axios.post(
      `${AUTH_URL}/super-admins`,
      { data: { email, type } },
      { headers: { ...(await getAuthHeader()) } }
    )

    if (ret.status === 201) {
      return ret.data
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.error(error.message)
    throw error
  }
}

export async function updateSuperAdmin({ id, email, type }) {
  try {
    const ret = await axios.put(
      `${AUTH_URL}/super-admins/${id}`,
      { data: { email, type } },
      { headers: { ...(await getAuthHeader()) } }
    )

    if (ret.status === 200) {
      return ret.data
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.error(error.message)
    throw error
  }
}

export async function deleteSuperAdmin({ id }) {
  try {
    const ret = await axios.delete(`${AUTH_URL}/super-admins/${id}`, {
      headers: { ...(await getAuthHeader()) }
    })

    if (ret.status === 200) {
      return ret.data
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.error(error.message)
    throw error
  }
}

export async function checkAdminStatus() {
  try {
    const ret = await axios.get(`${AUTH_URL}/super-admins/check-admin`, {
      headers: { ...(await getAuthHeader()) }
    })

    if (ret.status === 200) {
      return ret.data.isAdmin
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.error(error.message)
    return false
  }
}

export async function checkSuperAdminStatus() {
  try {
    const ret = await axios.get(`${AUTH_URL}/super-admins/check-super-admin`, {
      headers: { ...(await getAuthHeader()) }
    })

    if (ret.status === 200) {
      return ret.data.isSuperAdmin
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.error(error.message)
    return false
  }
}

export async function checkUserSearchAccess() {
  try {
    const ret = await axios.get(`${AUTH_URL}/super-admins/user-search-access`, {
      headers: { ...(await getAuthHeader()) }
    })

    if (ret.status === 200) {
      return ret.data.hasAccess
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.error(error.message)
    return false
  }
}

export async function searchSuperAdminUsers({ query = '', page = 1 }) {
  try {
    const ret = await axios.post(
      `${AUTH_URL}/super-admins/users/search`,
      {
        data: {
          query,
          page
        }
      },
      { headers: { ...(await getAuthHeader()) } }
    )

    if (ret.status === 200) {
      return ret.data
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.error(error.message)
    throw error
  }
}

export async function verifySuperAdminUserEmail({ uid, email }) {
  try {
    const ret = await axios.post(
      `${AUTH_URL}/super-admins/users/${uid}/verify-email`,
      {
        data: {
          email
        }
      },
      { headers: { ...(await getAuthHeader()) } }
    )

    if (ret.status === 200) {
      return ret.data
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.error(error.message)
    throw error
  }
}
